import React, {Component} from 'react';
import {
  Button,
  Input,
  Form,
  Select,
  Row,
  Col
} from 'antd';
const FormItem = Form.Item;
import CaptchaInput from '../../components/common/Captcha'

class ValidForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {form, onSend, isCodeSend, count, isCountDown, isReSet} = this.props;
    const {getFieldDecorator} = form;
    const keyInputLayout = {
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 10
        }
      }
    }
    let buttonText = isCountDown
      ? count + '秒后重发'
      : "发送验证码";
    return (
      <Form>
        <FormItem>
          {getFieldDecorator('mail', {
            rules: [
              {
                required: true,
                message: '输入公司邮箱！'
              }
            ]
          })(<Input placeholder="输入公司邮箱"/>)}
        </FormItem>
        <FormItem>
          {getFieldDecorator('captcha', {
            rules: [
              {
                required: true,
                message: '输入图片校验码！',
              },
              {
                len:4,
                message: '图片校验码是 4 位！'
              }
            ]
          })(<CaptchaInput isReSet={isReSet} placeholder="输入图片校验码"/>)}
        </FormItem>
        <FormItem>
          <Row>
            <Col span={12}>
              {getFieldDecorator('code', {
                rules: [
                  {
                    len: 4,
                    message: '输入验证码！'
                  }
                ]
              })(<Input placeholder="输入 4 位验证码" disabled={!isCodeSend}/>)}
            </Col>
            <Col span={12} style={{
              textAlign: "right"
            }}>
              <Button onClick={onSend} type="primary" disabled={isCountDown}>{buttonText}</Button>
            </Col>
          </Row>

        </FormItem>
      </Form>
    )
  }
}

export default Form.create()(ValidForm);


// WEBPACK FOOTER //
// ./src/components/login/validForm.js